import e from "../../utils/classNames.js";
import { getCurrentBackgroundColor as t } from "../../utils/currentColors.js";
import { forwardRef as n, useLayoutEffect as r, useRef as i, useState as a } from "react";
import { noop as o } from "es-toolkit/function";
import { jsx as s, jsxs as c } from "react/jsx-runtime";
//#region src/components/switch/Switch.tsx
var l = 40, u = 28, d = ({ enabledText: e, disabledText: t, minWidth: n, autoMinWidth: o }) => {
	let s = i(null), [c, d] = a(l), f = n !== void 0, p = [e, t].filter((e) => !!e).reduce((e, t) => t.length > e.length ? t : e, ""), m = !!(e || t), h = !f && o, g = f ? n : h ? c : m ? void 0 : l;
	return r(() => {
		if (!h) return;
		if (!p) {
			d(l);
			return;
		}
		let e = s.current?.offsetWidth ?? 0, t = Math.ceil(e) + u;
		d(Math.max(l, t));
	}, [p, h]), {
		computedMinWidth: g,
		longestText: p,
		shouldUseAutoTextWidth: h,
		textMeasureRef: s
	};
}, f = n((n, r) => {
	let { keyName: i, checked: a = !1, enabledText: l, minWidth: u, autoMinWidth: f = !1, disabled: p = !1, color: m = "primary", disabledText: h, children: g, className: _ = "", labelPosition: v = g ? "right" : void 0, onChange: y = o, customTextStyle: b = !1, ...x } = n, { computedMinWidth: S, longestText: C, shouldUseAutoTextWidth: w, textMeasureRef: T } = d({
		enabledText: l,
		disabledText: h,
		minWidth: u,
		autoMinWidth: f
	}), E = (e) => {
		y(e.target.checked);
	}, D = !!(l && h), O = !!(l && !h), k = e("uikit-switch", _), A = e("switch-label", k, p && "cursor-not-allowed", v && `label-position-${v}`, v === "left" && "display-inline-flex height-20"), j = e("switch-content"), M = t(m);
	return /* @__PURE__ */ s("div", {
		ref: r,
		...x,
		className: k,
		children: /* @__PURE__ */ c("label", {
			className: A,
			children: [
				w && C && /* @__PURE__ */ s("span", {
					ref: T,
					className: "switch-text-measure",
					"aria-hidden": "true",
					children: C
				}),
				/* @__PURE__ */ s("input", {
					onChange: E,
					checked: a,
					type: "checkbox",
					id: i,
					className: "switch-input",
					disabled: p
				}, i),
				/* @__PURE__ */ c("div", {
					className: j,
					style: {
						color: M,
						minWidth: S
					},
					children: [D ? /* @__PURE__ */ s("div", {
						className: "switch-text",
						"data-on": l,
						"data-off": h
					}) : O && /* @__PURE__ */ s("div", {
						className: "switch-text",
						"data-on": l,
						"data-off": l
					}), /* @__PURE__ */ s("div", { className: "switch-handle" })]
				}),
				g && /* @__PURE__ */ s("div", {
					className: e("switch-text-wrapper", "user-select-none", b ? "" : "padding-top-1"),
					children: g
				})
			]
		})
	});
});
f.LABEL_POSITION_LEFT = "left", f.LABEL_POSITION_RIGHT = "right";
//#endregion
export { f as default };

//# sourceMappingURL=Switch.js.map